// extracted by mini-css-extract-plugin
export default {"space_90":"index_space_90_Y8BEo","space_250":"index_space_250_qOK0X","space_500":"index_space_500_Av0Eq","column":"index_column_WB4sl"};